import { z } from 'zod';

export const locationDetailsSchema = z.object({
  placeId: z.string(),
  formattedAddress: z.string(),
  lat: z.number().optional(),
  lng: z.number().optional(),
});

export const createAppointmentSchema = z.object({
  title: z.string().min(1).max(100),
  location: z.string().min(1).max(200),
  locationDetails: locationDetailsSchema.optional(),
  startTime: z.string().min(1),
  duration: z.number().int().min(15).max(480),
  description: z.string().max(500).optional(),
  assignedTo: z.string().optional(),
});

export const createLocalizedAppointmentSchema = (t: (key: string) => string) =>
  z.object({
    title: z.string().min(1, t('forms.titleRequired')).max(100, t('forms.titleTooLong')),
    location: z.string().min(1, t('forms.locationRequired')).max(200, t('forms.locationTooLong')),
    locationDetails: locationDetailsSchema.optional(),
    startTime: z.string().min(1, t('forms.startTimeRequired')),
    duration: z.number().int().min(15, t('forms.durationMin')).max(480, t('forms.durationMax')),
    description: z.string().max(500, t('forms.descriptionTooLong')).optional(),
    assignedTo: z.string().optional(),
  });

export const appointmentSchema = createAppointmentSchema.extend({
  id: z.string(),
  createdBy: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  assignedTo: z.string().optional(),
  assignedToName: z.string().optional(),
  createdByName: z.string().optional(),
  status: z.enum(['unassigned', 'assigned', 'completed']).default('unassigned'),
});

export type LocationDetails = z.infer<typeof locationDetailsSchema>;
export type Appointment = z.infer<typeof appointmentSchema>;
export type CreateAppointmentRequest = z.infer<typeof createAppointmentSchema>;
